import z from "zod";

import { nullableToOptional } from "./utils";

export const AddressSchema = z.object({
  createdAt: nullableToOptional(z.string()),
  updatedAt: nullableToOptional(z.string()),
  deletedAt: nullableToOptional(z.string()),
  id: nullableToOptional(z.number()),
  country: nullableToOptional(z.string()),
  city: nullableToOptional(z.string()),
  state: nullableToOptional(z.string()),
  county: nullableToOptional(z.string()),
  address1: nullableToOptional(z.string()),
  address2: nullableToOptional(z.string()),
  premise: nullableToOptional(z.string()),
  unit: nullableToOptional(z.string()),
  zipcode: nullableToOptional(z.string()),
  latitude: nullableToOptional(z.number()),
  longitude: nullableToOptional(z.number()),
  location: nullableToOptional(z.string()),
});
